import { render, staticRenderFns } from "./DownloadDocs.vue?vue&type=template&id=f297dc3c&"
import script from "./DownloadDocs.vue?vue&type=script&lang=js&"
export * from "./DownloadDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports